import React from 'react';
import LogItem from './LogItem';

const KpiEntryLogItem = ({ event }) => {
  const details = {
    itemType: 'kpiEntry',
    actualItem: event?.kpiEntry,
    previousItem: event?.oldKpiEntry,
    ...event
  };

  return (
    <LogItem event={ details }/>
  );
};

export default KpiEntryLogItem;
